import script from "./task.vue?vue&type=script&setup=true&lang=js"
export * from "./task.vue?vue&type=script&setup=true&lang=js"

import "./task.vue?vue&type=style&index=0&id=7a77454e&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a77454e"]])

export default __exports__